/* eslint-disable css-modules/no-unused-class */
import { FC, useState, useEffect } from 'react';
import { CourseProgressProps } from './courseProgressTypes';
import styles from './courseProgress.module.scss';

const CourseProgress: FC<CourseProgressProps> = (props: CourseProgressProps) => {
    const { totalLessons, doneIndexes = [], parentWidth, nextIndex } = props;
    const [itemWidth, setItemWidth] = useState<number>(0);
    const items = new Array(totalLessons).fill('');
    const itemsSpace = 4;

    useEffect(() => {
        setItemWidth((parentWidth - totalLessons * itemsSpace - 2) / totalLessons);
    }, [totalLessons]);

    const getClassName = (index: number): string => {
        if (doneIndexes.includes(index)) return styles.done;
        if (index === nextIndex) return styles.current;
        return styles['not-done'];
    };
    return (
        <div data-testid="course-progress" className={styles['course-progress']}>
            {items.map((_, i) => (
                <div
                    key={i}
                    data-testid="course-progress-item"
                    className={getClassName(i)}
                    style={{ '--width': `${itemWidth}px` } as any}
                ></div>
            ))}
        </div>
    );
};

export default CourseProgress;
